import { Grid } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RightSlider } from '../../../../../../components/sliders'
import { AppDispatch } from '../../../../../../store'
import { TechGrantsActions, TechGrantSelectors } from '../../../../../../store/technology'
import { ProjectGrant } from '../../../../../Projects/subComponents/Project/sharedComponents/ProjectGrant'
import { GrantCard } from './GrantCard'

interface SmallBusinessAndFederalProps {
  grantType: ['sbir', 'sttr'] | ['federal']
}

export const SmallBusinessAndFederal: FC<SmallBusinessAndFederalProps> = ({ grantType }) => {
  const dispatch = useDispatch<AppDispatch>()

  const [showGrantDetail, setShowGrantDetail] = useState(false)
  const [selectedGrant, setSelectedGrant] = useState({ projectId: '', refId: '' })

  const grants = useSelector(TechGrantSelectors.makeGrantsSummary)

  useEffect(() => {
    const options = {
      params: {
        $limit: 4,
        grantType: grantType.join(','),
      },
    }

    dispatch(TechGrantsActions.fetchCurrentUserMatchedGrantsAsync({ options }))
  }, [dispatch, grantType])

  const handleGrantDetailSlideOut = (projectId: string, refId: string) => {
    setSelectedGrant({ projectId, refId })
    setShowGrantDetail(true)
  }

  return (
    <Grid my={2} container spacing={2}>
      <RightSlider
        open={showGrantDetail}
        setOpen={setShowGrantDetail}
        closeButtonAction={() => setShowGrantDetail(false)}
      >
        <ProjectGrant projectId={selectedGrant.projectId} refId={selectedGrant.refId} />
      </RightSlider>

      {grants &&
        grants.map((grant) => {
          const {
            _id,
            title,
            agency,
            topicId,
            closeDate,
            technologyId,
            technologyTitle,
            formattedAwardAmount,
          } = grant

          return (
            <Grid
              key={_id}
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                handleGrantDetailSlideOut(technologyId, topicId)
              }}
            >
              <GrantCard
                agency={agency}
                grantTitle={title}
                deadline={closeDate}
                technologyTitle={technologyTitle}
                awardAmount={formattedAwardAmount}
              />
            </Grid>
          )
        })}
    </Grid>
  )
}
